export * from './src/dynamic-page-router-v1-page-pages.universal.js';
